import { css, Theme } from '@emotion/react'
import { alpha } from '@mui/material'
import { CHART_HEIGHT } from '../styles'
import { tooltipContentClasses } from '../TooltipContent'

export const headingWrapper = (theme: Theme) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;

  ${theme.breakpoints.down(768)} {
    row-gap: 22px;
    flex-direction: column;
    align-items: flex-start;
  }
`

export const chartWrapper = css`
  position: relative;
`

export const chartDataLoaderWrapper = (theme: Theme) => css`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 16px;

  background-color: ${alpha(theme.backgrounds.backgroundOne, 0.9)};
`

export const chart = (theme: Theme) => css`
  padding: 4px 0 12px 12px;
  height: ${CHART_HEIGHT}px;

  ${theme.breakpoints.down(768)} {
    margin: 18px 0 12px 8px;
  }
`

export const tooltipWrapper = (theme: Theme) => css`
  border-radius: 6px;
  box-shadow: 0px -1px 0px 0px ${alpha(theme.colors.white, 0.04)}, 0px 0px 0px 1px ${alpha(theme.colors.white, 0.12)},
    0px 2px 4px 0px ${alpha(theme.colors.black, 0.32)}, 0px 4px 8px 0px ${alpha(theme.colors.black, 0.32)};
`

export const tooltipContent = (theme: Theme) => css`
  .${tooltipContentClasses.li} {
    &:nth-of-type(1) {
      .${tooltipContentClasses.itemContentTitle} {
        color: ${theme.colors.accent};
      }
    }

    &:nth-of-type(2) {
      .${tooltipContentClasses.itemContentValue} {
        color: ${theme.colors.accent};
      }
    }
  }
`
